export interface AudienceFilterRow {
    id: string;
    attributeName: string | null;
}

interface ReconcileRowsParams {
    rows: AudienceFilterRow[];
    selectedAttributeNames: string[];
}

interface SameRowsParams {
    left: AudienceFilterRow[];
    right: AudienceFilterRow[];
}

const ROW_ID_PREFIX = 'row';

const nextRowId = (rows: AudienceFilterRow[]): string => {
    const takenIds = new Set(rows.map((row) => row.id));
    let index = 0;

    while (takenIds.has(`${ROW_ID_PREFIX}-${index}`)) {
        index += 1;
    }

    return `${ROW_ID_PREFIX}-${index}`;
};

export const createEmptyRow = (rows: AudienceFilterRow[]): AudienceFilterRow => ({
    id: nextRowId(rows),
    attributeName: null,
});

export const reconcileRows = ({
    rows,
    selectedAttributeNames,
}: ReconcileRowsParams): AudienceFilterRow[] => {
    const selected = new Set(selectedAttributeNames);
    const reconciled = rows.filter(
        (row) => row.attributeName === null || selected.has(row.attributeName),
    );
    const alreadyPlaced = new Set(reconciled.map((row) => row.attributeName));

    selectedAttributeNames.forEach((attributeName) => {
        if (alreadyPlaced.has(attributeName)) {
            return;
        }

        reconciled.push({ id: nextRowId(reconciled), attributeName });
    });

    return reconciled.length > 0 ? reconciled : [createEmptyRow([])];
};

export const areSameRows = ({ left, right }: SameRowsParams): boolean =>
    left.length === right.length &&
    left.every(
        (row, index) =>
            row.id === right[index].id && row.attributeName === right[index].attributeName,
    );
